import * as React from 'react';
import { useContext } from 'react';
import { useSelector } from 'react-redux';

import { ProsContainer } from './ProsContainer';
import { ConsContainer } from './ConsContainer';
import { ProsAndCons } from '../../../components/NewReviewModal/parts/NewReviewModalReview/parts/ProsAndCons';
import { DailyrentNewReviewModalFooterContainer } from '../../DailyrentNewReviewModalFooter';
import { FormModalLayout } from '../../../components/FormLayout';
import { NewReviewContext } from '../../../utils/newReview/context';
import { getNewReviewLoadingError } from '../../../selectors/newReview/getNewReviewLoadingError';
import { ErrorSnackbar } from '../../../components/DailyrentNewReview/ErrorSnackbar';
import * as styles from './styles.css';
import { trackShow } from './tracking';
import { useApplicationContext } from '../../../utils/applicationContext';
import { getObjectId } from '../../../selectors/objectInfo';
import { getNewReviewData } from '../../../selectors/newReview/getNewReviewData';

export const ReviewContainer = () => {
  const { custom } = useApplicationContext();
  const objectId = useSelector(getObjectId);
  const { isOpened, onClose } = useContext(NewReviewContext);
  const formState = useSelector(getNewReviewData);
  const hasLoadingError = useSelector(getNewReviewLoadingError);

  React.useEffect(() => {
    if (isOpened) {
      trackShow(objectId, formState, custom.deviceType);
    }
  }, [isOpened]);

  return (
    <FormModalLayout
      title="Новый отзыв"
      shortTitle="Новый отзыв"
      footer={<DailyrentNewReviewModalFooterContainer nextButtonText="Опубликовать" />}
      onClose={onClose}
      type="form"
      open={isOpened}
      testId="NewReview"
    >
      <div className={styles['content']}>
        <ProsAndCons
          title="Расскажите подробнее, это поможет другим гостям определиться с выбором"
          pros={<ProsContainer />}
          cons={<ConsContainer />}
        />
        <ErrorSnackbar isOpen={hasLoadingError} message="Не получилось, попробуйте ещё раз" />
      </div>
    </FormModalLayout>
  );
};
